(() => {
  const storageKey = 'gd_gym_package';

  function getItems() {
    try {
      const items = JSON.parse(localStorage.getItem(storageKey) || '[]');
      return Array.isArray(items) ? items : [];
    } catch (error) {
      return [];
    }
  }

  function saveItems(items) {
    localStorage.setItem(storageKey, JSON.stringify(items));
  }

  function normalizeUrl(url) {
    try {
      return new URL(url, window.location.origin).pathname;
    } catch (error) {
      return url;
    }
  }

  function updateUi() {
    const items = getItems();
    const savedUrls = new Set(items.map((item) => normalizeUrl(item.url)));

    document.querySelectorAll('[data-gd-favorite-toggle]').forEach((button) => {
      const active = savedUrls.has(normalizeUrl(button.dataset.productUrl));
      const label = active ? 'Ta bort från favoriter' : 'Lägg till i favoriter';

      button.classList.toggle('is-active', active);
      button.setAttribute('aria-pressed', String(active));
      button.setAttribute('aria-label', label);
      button.setAttribute('title', label);

      const hiddenLabel = button.querySelector('[data-gd-favorite-label]');
      if (hiddenLabel && hiddenLabel.textContent !== label) hiddenLabel.textContent = label;
    });

    document.querySelectorAll('[data-gd-favorites-count]').forEach((badge) => {
      if (badge.textContent !== String(items.length)) badge.textContent = String(items.length);
      badge.hidden = items.length === 0;
    });
  }

  function notify() {
    updateUi();
    document.dispatchEvent(new CustomEvent('gd:favorites:change', { detail: { items: getItems() } }));
  }

  document.addEventListener('click', (event) => {
    const button = event.target.closest('[data-gd-favorite-toggle]');
    if (!button) return;

    event.preventDefault();
    event.stopPropagation();

    const item = {
      title: button.dataset.productTitle,
      url: button.dataset.productUrl,
      image: button.dataset.productImage,
      sku: button.dataset.productSku
    };
    const items = getItems();
    const itemUrl = normalizeUrl(item.url);
    const existingIndex = items.findIndex((savedItem) => normalizeUrl(savedItem.url) === itemUrl);

    if (existingIndex === -1) {
      items.push(item);
    } else {
      items.splice(existingIndex, 1);
    }

    saveItems(items);
    notify();
  });

  document.addEventListener('DOMContentLoaded', updateUi);
  window.addEventListener('pageshow', updateUi);
  window.addEventListener('storage', updateUi);

  const observer = new MutationObserver((mutations) => {
    if (mutations.some((mutation) => mutation.addedNodes.length > 0)) updateUi();
  });

  document.addEventListener('DOMContentLoaded', () => {
    observer.observe(document.body, { childList: true, subtree: true });
  });

  window.GymdealenFavorites = { getItems, saveItems, updateUi, notify };
})();
